import React from 'react';
import { PreviewBaseProps } from '../PreviewContents';
import Button from '../Button';

export interface PreviewHeaderProps extends PreviewBaseProps {
  /**
   * 編集情報
   * 編集機能が必要な場合のみ指定
   */
  editInfo?: {
    /**
     * 編集対象データのキー
     */
    uniqueId: string;
    /**
     * 表示するボタンのラベル
     */
    label: string;
    /**
     * ボタンを押下した際の動作
     * @returns void
     */
    onClickEditHandler: () => void;
  };
  /**
   * 画面遷移情報
   * 遷移ボタンが必要な場合のみ指定
   */
  detailInfo?: {
    /**
     * 表示するボタンのラベル
     */
    label: string;
    /**
     * ボタンを押下した際の動作
     * @returns void
     */
    onClick: () => void;
  };
}

const PreviewHeader: React.FC<PreviewHeaderProps> = ({ title, uniqueId, editInfo = undefined, detailInfo = undefined }) => {
  return (
    <div className='u-h3l'>
      <div className='u-float-left u-h100p vertical-align-area-parent'>
        <div className='vertical-align-area-child'>
          <h2 className='u-text-bold u-text-2l ' data-testid={uniqueId} data-testid-e2e={uniqueId}>
            {title}
          </h2>
        </div>
      </div>
      {detailInfo && (
        <div className='u-float-right u-h100p vertical-align-area-parent u-ml8'>
          <div className='vertical-align-area-child'>
            <Button
              className='u-text-middle'
              type='transparent'
              label={detailInfo.label}
              rightIcon='chevron_right'
              onClick={detailInfo.onClick}
              data-testid={`detail-btn-on-${uniqueId}`}
              data-testid-e2e={`detail-btn-on-${uniqueId}`}
            />
          </div>
        </div>
      )}
      {editInfo && (
        <div className='u-float-right u-h100p vertical-align-area-parent'>
          <div className='vertical-align-area-child'>
            <Button
              className='u-text-middle'
              type='transparent'
              leftIcon='edit'
              label={editInfo.label}
              onClick={editInfo.onClickEditHandler}
              data-testid={`edit-btn-on-${uniqueId}`}
              data-testid-e2e={`edit-btn-on-${uniqueId}`}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PreviewHeader;
